// import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

function initHeader() {
  const header = document.querySelector(".header") as HTMLElement;

  if (!header) return;

  const menuToggle = header.querySelector(".header-toggle-menu") as HTMLButtonElement;
  const menuWrapper = header.querySelector(".header-mobile-wrapper") as HTMLElement;

  function closeMenu() {
    header.classList.remove("mobile-menu-open");
    menuToggle.setAttribute("aria-pressed", "false");
  }

  menuToggle.addEventListener("click", () => {
    const isOpen = menuToggle.getAttribute("aria-pressed") === "true";
    menuToggle.setAttribute("aria-pressed", isOpen ? "false" : "true");
    header.classList.toggle("mobile-menu-open");
  });

  window.addEventListener("resize", closeMenu);

  document.addEventListener("click", (event) => {
    if (!header.contains(event.target as Node)) {
      closeMenu();
    }
  });
}

initHeader();
